import Swal from 'sweetalert2';

export const catchErros = error => {
  if (error?.response?.data?.field && error.response.data.fields[0]) {
    Swal.fire({
      title: 'Atenção',
      text: `${String(
        error?.response?.data?.fields[0]?.parameter
      ).toUpperCase()}: ${error?.response?.data?.fields[0]?.exception}`,
      icon: 'error',
      confirmButtonColor: '#74a50a',
    }).then(() => {
      window.location.reload();
    });
  } else {
    Swal.fire({
      title: 'Atenção',
      text: ` ${error?.response?.data?.error}`,
      icon: 'error',
      confirmButtonColor: '#74a50a',
    }).then(() => {
      window.location.reload();
    });
  }
};

export const messageSuccess = response => {
  if (response?.data && response?.data?.menssagem) {
    Swal.fire({
      title: 'Obrigado!',
      text: `${String(response?.data?.menssagem)}`,
      icon: 'success',
      confirmButtonColor: '#74a50a',
      confirmButtonText: 'Ok! Obrigado!',
    }).then(() => {
      return true;
    });
  }
};

export const messageAlert = data => {
  Swal.fire({
    title: 'Atenção',
    html: `<p style="padding:10px 50px"> ${String(data)} </p>`,
    icon: 'warning',
    confirmButtonColor: '#74a50a',
  });
};
